import { render, staticRenderFns } from "./form-image.vue?vue&type=template&id=fa005f62&"
import script from "./form-image.vue?vue&type=script&lang=js&"
export * from "./form-image.vue?vue&type=script&lang=js&"
import style0 from "./form-image.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-image.vue"
export default component.exports